export const appFeatures = [
  { id: "af1", icon: "ri-download-2-line", title: "极速安装", desc: "安装包精简，装完即用，不占用多余空间。" },
  { id: "af2", icon: "ri-flashlight-line", title: "秒开线路", desc: "内置多线路自动测速，打开自动选最快的一条。" },
  { id: "af3", icon: "ri-bookmark-3-line", title: "入口记忆", desc: "自动记录可用入口，换地址也不用重新找。" },
  { id: "af4", icon: "ri-notification-3-line", title: "更新推送", desc: "线路变更时第一时间提醒，不错过最新地址。" },
  { id: "af5", icon: "ri-database-2-line", title: "缓存省流", desc: "常用画面本地缓存，重复访问更省流量。" },
  { id: "af6", icon: "ri-shield-check-line", title: "清爽体验", desc: "精简干扰元素，专注内容本身，阅读更顺。" },
];

export const noticeTicker = [
  "【10:24 更新】线路一、线路四延迟恢复正常，当前推荐使用",
  "【公告】本页仅提供入口导航与地址汇总，不存储、不生产任何内容",
  "【提醒】把本页加入书签，地址变动后刷新即可获取最新可用入口",
  "【线路】线路三当前处于繁忙状态，建议优先切换其他线路",
];